import { Button, DefaultCard, DefaultContent } from '../../components';
import { Form, Formik, getIn } from 'formik';
import { FunctionComponent, useEffect, useRef, useState } from 'react';

import { ButtonTypeEnum } from '../../enums';
import { CheckboxField } from '../forms';
import { EleicaoTermosType } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TIME_TO_ENABLE_CHECKBOX_TERMOS = 10; // em segundos
const PRAZO_CRIACAO_ELEICAO = process.env.REACT_APP_ANTECEDENCIA_MINIMA_CRIACAO_ELEICAO;
const PRAZO_ALTERACAO_ELEICAO = process.env.REACT_APP_ANTECEDENCIA_MINIMA_ALTERACAO_ELEICAO;

const EleicaoTermos: FunctionComponent<EleicaoTermosType> = ({ termosAceitos, setTermosAceitos }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [checkboxTermosDisabled, setCheckboxTermosDisabled] = useState(true);
  const [countdownCheckboxTermos, setCountdownCheckboxTermos] = useState(TIME_TO_ENABLE_CHECKBOX_TERMOS);
  const countdownCheckboxTermosRef = useRef(countdownCheckboxTermos);

  useEffect(() => {
    countdownCheckboxTermosRef.current = countdownCheckboxTermos;
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const nextCount = countdownCheckboxTermosRef.current - 1;
      setCountdownCheckboxTermos(nextCount);

      if (nextCount <= 0) {
        clearInterval(timer);
        setCheckboxTermosDisabled(false);
      }
    }, 1000);
  }, []);

  return (
    <DefaultContent title={t('label.cadastrar_eleicao')}>
      <Formik
        initialValues={{ aceito_termos: false }}
        onSubmit={(values, { setSubmitting }) => {
          setTermosAceitos(true);
          setSubmitting(false);
        }}
      >
        {(props) => (
          <Form>
            <DefaultCard
              cardTitle={termosAceitos ? t('label.cadastrar_eleicao') : t('label.termos_condicoes_cadastro_eleicao')}
              footer={
                <div className="d-flex justify-content-center gap-5">
                  <Button title={t('label.cancelar')} onClick={() => navigate('/eleicoes')} outline />
                  <Button
                    title={`${t('label.aceitar')}${countdownCheckboxTermos > 0 ? ` (${countdownCheckboxTermos}) ` : ''}`}
                    type={ButtonTypeEnum.SUBMIT}
                    disabled={!getIn(props.values, 'aceito_termos')}
                  />
                </div>
              }
            >
              <div
                className="mb-3 text-break"
                dangerouslySetInnerHTML={{
                  __html: t('texto.termos_cadastro_eleicao_parte_1', {
                    prazo_alteracao_eleicao: PRAZO_ALTERACAO_ELEICAO,
                    prazo_criacao_eleicao: PRAZO_CRIACAO_ELEICAO,
                  }),
                }}
              ></div>
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <div
                  className="text-break"
                  dangerouslySetInnerHTML={{ __html: t('texto.termos_cadastro_eleicao_parte_2') }}
                ></div>
              </div>
              <CheckboxField
                formikProps={props}
                label={t('texto.aceitar_termos_condicoes_cadastro_eleicao')}
                name="aceito_termos"
                disabled={checkboxTermosDisabled}
              />
            </DefaultCard>
          </Form>
        )}
      </Formik>
    </DefaultContent>
  );
};

export default EleicaoTermos;
